<template>
    <div id="cropmeleft" class="col-md-2 sidebar">
        <h3>Aktuell</h3>
        <nav id="aktuellervorgang" class="nav flex-column">
            <li>{{ aktuellerVorgang }}</li>
        </nav>

        <h3>Anstehend</h3>
        <nav id="anstehende" class="nav flex-column">
            
            <li v-for="(cur_vorgang,idx) in vorgaenge" :key="idx" v-if="idx <= max_anstehende_links_zeigen">
                <router-link :to="cur_vorgang.url">{{ cur_vorgang.id }}</router-link>
            </li>
            
            <li v-if="vorgaenge.length > max_anstehende_links_zeigen" class="nochmehr">
                ... und noch {{ vorgaenge.length - max_anstehende_links_zeigen }} mehr
            </li>
        </nav>
    </div>

</template>

<script>
// Mixin fuer diese Komponente importieren
import commonvars from './mixins/commonvars.js';

export default {
    props: [
        'anzahlOffeneVorgaenge',
        'offeneVorgaenge',
        'aktuellerVorgang',
        'customer'
    ],
    mixins: [
        commonvars
    ],
    watch: {
        // Prop offeneVorgaenge aendert sich kurz nach Aufruf
        // dieser Komponente, weil die Mutter die Werte vom Webserver
        // etwas verzögert bekommt ->
        offeneVorgaenge: function() {
            this.erzeuge_id_und_url_fuer_offene_vorgaenge();
        }
    },
    data() {
        return {
            cur_vorgang: {},
            // wird gleich in mounted erzeugt:
            vorgaenge: [
                //{
                //    id: 12,
                //    url: 'http://juhei.de/' + 12
                //}
            ],
            max_anstehende_links_zeigen: 500
        }
    },
    mounted: function() {
        this.erzeuge_id_und_url_fuer_offene_vorgaenge();
    },
    methods: {
        erzeuge_id_und_url_fuer_offene_vorgaenge: function() {
            let vorgaenge_mit_url = [];
            for (let i=0; i<this.offeneVorgaenge.length; ++i) {
                let cur_vorgang_id = this.offeneVorgaenge[i];
                if (cur_vorgang_id == this.aktuellerVorgang) {
                    continue;
                }
                vorgaenge_mit_url.push({
                    "id": cur_vorgang_id,
                    "url": this.url_fuer_vorgang_in_link_element(cur_vorgang_id)
                });
            }
            this.vorgaenge=vorgaenge_mit_url;
        },
        // nicht volle url, weil das hier in einem vue-link-Element benutzt wird
        url_fuer_vorgang_in_link_element: function(cur_vorgang_id) {
            return "/cropme/" 
                + this.customer
                + "/vorgang/"
                + cur_vorgang_id;
        }
    }
}
</script>


<style scoped>
#aktuellervorgang li {
    font-size: 200%;
    padding-left: 10px;
    padding-bottom: 30px;
}

#anstehende li {
    font-size: 200%;
    padding-left: 10px;
    padding-top:10px;
    padding-bottom:10px;
}

#anstehende li a {
    display: block;
    text-decoration: none;
}

#anstehende li:hover {
    background-color: #FFC107;
}

#anstehende li.nochmehr:hover {
    background-color: transparent;
}

#anstehende li.nochmehr {
    color: grey;
    font-size: 100%;
}
</style>